import styled from '@emotion/styled';
import React, { AnchorHTMLAttributes } from 'react';
import { button, ButtonProps } from '~/utils/styles/mixins/button';
import { margins, MarginsProps } from '~/utils/styles/mixins/margins';
import { shouldForwardProp } from '~/utils/styles/utils';

type Props = AnchorHTMLAttributes<HTMLAnchorElement> &
  ButtonProps &
  MarginsProps;

export const ConnectedLink: React.FC<Props> = ({ href, ...rest }) => {
  return <AnchorLink href={href} {...(rest as Props)} />;
};

const AnchorLink = styled('a', {
  shouldForwardProp: shouldForwardProp({
    ignore: ['color', 'block'],
  }),
})<Props>`
  ${button}
  ${margins};
`;
